// TODO: remove hardcoded wordings - use translations override/phraseapp
import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TUVComparisonChart = () => {
  const {
    i18n
  } = useLingui();
  const chartData = [{
    img: {
      src: i18n._('carlead.tuv.priceComparisonChart.labelSrc.enrty1'),
      className: 'img-responsive logo mt-n1',
      alt: i18n._('carlead.tuv.priceComparisonChart.labelAlt.enrty1')
    },
    value: i18n._('carlead.tuv.priceComparisonChart.value.enrty1')
  }, {
    label: i18n._('carlead.tuv.priceComparisonChart.label.enrty2'),
    value: i18n._('carlead.tuv.priceComparisonChart.value.enrty2')
  }, {
    label: i18n._('carlead.tuv.priceComparisonChart.label.enrty3'),
    value: i18n._('carlead.tuv.priceComparisonChart.value.enrty3')
  }, {
    label: i18n._('carlead.tuv.priceComparisonChart.label.enrty4'),
    value: i18n._('carlead.tuv.priceComparisonChart.value.enrty4')
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "comparison-chart",
    children: [/*#__PURE__*/_jsx("div", {
      className: "vertical-line"
    }), chartData.map((item, index) => /*#__PURE__*/_jsxs("div", {
      className: "chart-row",
      children: [/*#__PURE__*/_jsx("div", {
        className: "chart-label",
        children: item.label ? /*#__PURE__*/_jsx("span", {
          children: item.label
        }) : /*#__PURE__*/_jsx("picture", {
          children: /*#__PURE__*/_jsx("img", {
            src: item.img.src,
            className: item.img.className,
            alt: item.img.alt
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "chart-bar-container",
        children: /*#__PURE__*/_jsx("div", {
          className: `chart-bar chart-bar-${index + 1}`,
          children: /*#__PURE__*/_jsx("span", {
            className: "chart-value",
            children: item.value
          })
        })
      })]
    }, index))]
  });
};